import React, { useState } from "react";
import { css } from "@emotion/core";
import { Row, Col, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import CompaniesDropdown from "../company-dropdown";
import DashboardNewSpaceModal from "../new-space-modal";
import DashboardResubcribeModal from "../resubscribe-modal";
import NewSpaceButton from "../new-space-button";
import MobileMenu from "../menu-dropdown";
import MoonLoader from "react-spinners/MoonLoader";
import InformationMessage from "../information-message";
import { useMediaQuery } from "react-responsive";
import logoDark from "../../../img/logo-light.png";
import * as accountThumbnail from "../../../img/profile.png";
import { setActivePage } from "../../../redux/actions/active-page";
import {
  sendErrorNotification,
  sendSuccessNotification,
} from "../notifications/notifications";
import DropdownMenu from "../../universal/dropdown-menu";
import { auth } from "firebase";
import "./style.scss";
import {
  requestAcceptInvitation,
  requestFetchNotifications,
  requestRejectInvitation,
  requestUpdateUnseenNotifications,
  resetAcceptInvitation,
  resetFetchNotifications,
  resetRejectInvitation,
  resetUpdateUnseenNotifications,
  retrieveUserDetails,
} from "../../../redux/actions/user";
import { useEffect } from "react";

const override = css`
  border-color: #5d78ff;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

const DashboardUpperNavigation = () => {
  const dispatch = useDispatch();

  const activeLoading = useSelector(
    (state) => state && state.activeCompany && state.activeCompany.loading
  );
  const notifications = useSelector(
    (state) => state.user?.details?.notifications
  );
  const userInfo = useSelector((state) => state.user && state.user.details);

  const stateIndex = useSelector((state) => state && state.activePage);

  const company = useSelector(
    (state) => state && state.activeCompany && state.activeCompany.activeCompany
  );

  const infoLoading = useSelector(
    (state) => state.user.fetchUserDetails.loading
  );
  const nameLoading = useSelector((state) => state.user.fetchName.loading);
  const authLoading = useSelector(
    (state) => state.user.fetchUserDetails.loading
  );

  const uploadLoading = useSelector((state) => state.user.updateImage.loading);
  const deleteLoading = useSelector((state) => state.user.deleteImage.loading);
  const thumbnailLoading = useSelector(
    (state) => state.user.fetchThumbnail.loading
  );

  const rejectInvitationStatus = useSelector(
    (state) => state.user.rejectInvitation.status
  );
  const rejectInvitationError = useSelector(
    (state) => state.user.rejectInvitation.error
  );

  const acceptInvitationStatus = useSelector(
    (state) => state.user.acceptInvitation.status
  );
  const acceptInvitationError = useSelector(
    (state) => state.user.acceptInvitation.error
  );

  const updateUnseenNotificationsStatus = useSelector(
    (state) => state.user.updateUnseenNotifications.status
  );

  const fetchNotificationsListStatus = useSelector(
    (state) => state.user.fetchNotificationsList.status
  );
  const fetchNotificationsListError = useSelector(
    (state) => state.user.fetchNotificationsList.error
  );

  //const updateUnseenNotificationsError = useSelector(state => state.user.updateUnseenNotifications.error)

  const modal = useSelector((state) => state.universal.showModals);
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const [mobileMainMenuOpen, setMobileMainMenuOpen] = useState(false);
  const [mobileCompaniesMenuOpen, setMobileCompaniesMenuOpen] = useState(false);

  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [notificationsDropdownOpen, setNotificationsDropdownOpen] =
    useState(false);

  const history = useHistory();
  const { activePage } = stateIndex;

  const navigatePage = (destination) => {
    switch (destination) {
      case "overview":
        dispatch(setActivePage("overview"));
        history.push("/dashboard/oversikt");
        break;
      case "lists":
        dispatch(setActivePage("lists"));
        history.push("/dashboard/lister");
        break;
      case "clients":
        dispatch(setActivePage("clients"));
        history.push("/dashboard/kunder");
        break;
      case "messages":
        dispatch(setActivePage("messages"));
        history.push("/dashboard/samtaler");
        break;
      case "pipeline":
        dispatch(setActivePage("pipeline"));
        history.push("/dashboard/pipeline");
        break;
      case "calendar":
        dispatch(setActivePage("calendar"));
        history.push("/dashboard/kalender");
        break;
      case "library":
        dispatch(setActivePage("library"));
        history.push("/dashboard/bibliotek");
        break;
      case "company":
        dispatch(setActivePage("company"));
        history.push("/dashboard/foretak");
        break;
      default:
        break;
    }
  };

  const renderMenuDisplay = (target) => {
    if (activePage === target) {
      if (!activeLoading) {
        if (company && company.subscription) {
          return "menu-button w-100 d-block pt-2 pb-2 active";
        } else {
          return "menu-button w-100 d-block invalid pt-2 pb-2";
        }
      } else {
        return "menu-button w-100 d-block pt-2 pb-2";
      }
    } else {
      if (!activeLoading) {
        if (company && company.subscription) {
          return "menu-button w-100 d-block pt-2 pb-2";
        } else {
          return "menu-button w-100 invalid d-block pt-2 pb-2";
        }
      } else {
        return "menu-button w-100 d-block pt-2 pb-2";
      }
    }
  };

  const performSignout = async () => {
    try {
      await auth().signOut();
      history.push("/logg-inn");
    } catch (e) {
      sendErrorNotification("Kunne ikke logge ut.");
    }
  };

  const renderThumbnail = () => {
    if (!infoLoading) {
      if (userInfo.thumbnail) {
        return userInfo.thumbnail;
      } else {
        return accountThumbnail;
      }
    } else {
      return accountThumbnail;
    }
  };

  const renderProfileToggle = () => {
    return (
      <Dropdown.Toggle
        onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}
        disabled={infoLoading ? true : false}
        id="dropdown-filter"
      >
        <div className="toggle-container">
          <span className="thumbnail">
            <img src={renderThumbnail()} />
          </span>
          <span className="name-container">
            {!infoLoading && userInfo.firstName
              ? `${userInfo.firstName} ${userInfo.lastName}`
              : "Laster inn.."}
          </span>
        </div>
      </Dropdown.Toggle>
    );
  };

  const renderNotificationsToggle = () => {
    return (
      <Dropdown.Toggle
        onClick={() => setNotificationsDropdownOpen(!notificationsDropdownOpen)}
        disabled={infoLoading ? true : false}
        id="dropdown-filter"
      >
        <div className="toggle-container">
          <span className="bell-icon">
            <i className="far fa-bell"></i>
          </span>
          <div
            className={
              !infoLoading &&
              notifications &&
              notifications.content?.some((n) => n.seen === false) > 0
                ? "badge"
                : "badge hidden"
            }
          >
            &nbsp;
          </div>
        </div>
      </Dropdown.Toggle>
    );
  };

  const renderUserMenuOptions = () => {
    const options = [
      {
        title: "Min profil",
        key: "myprofile",
        action: () => history.push("/dashboard/konto"),
      },
      {
        title: "Logg ut",
        key: "logout",
        action: () => performSignout(),
      },
    ];
    return options;
  };

  const renderUserDetails = () => {
    if (!infoLoading && userInfo.firstName) {
      return {
        name: `${userInfo.firstName ? userInfo.firstName : ""} ${
          userInfo.lastName ? userInfo.lastName : ""
        }`,
        roles: userInfo.companies.length,
        thumbnail: renderThumbnail(),
      };
    }
    return {
      name: `Ikke tilgjengelig`,
      roles: 0,
      thumbnail: null,
    };
  };

  const clickAcceptRequest = (id) => {
    dispatch(requestAcceptInvitation({ id: id }));
  };

  const clickRejectRequest = (id) => {
    dispatch(requestRejectInvitation({ id: id }));
  };

  useEffect(() => {
    if (rejectInvitationStatus) {
      sendSuccessNotification("Du avviste invitasjonen.");
      dispatch(requestFetchNotifications({ start: null }));
      dispatch(resetRejectInvitation());
    }
  }, [rejectInvitationStatus]);

  useEffect(() => {
    if (rejectInvitationError) {
      sendErrorNotification("Kunne ikke avvise invitasjon.");
      dispatch(resetRejectInvitation());
    }
  }, [rejectInvitationError]);

  useEffect(() => {
    if (acceptInvitationStatus) {
      sendSuccessNotification("Du godkjente invitasjonen.");
      dispatch(requestFetchNotifications({ start: null }));
      dispatch(retrieveUserDetails(auth().currentUser?.uid));
      dispatch(resetAcceptInvitation());
    }
  }, [acceptInvitationStatus]);

  useEffect(() => {
    if (acceptInvitationError) {
      sendErrorNotification("Kunne ikke godta invitasjonen.");
      dispatch(resetAcceptInvitation());
    }
  }, [acceptInvitationError]);

  useEffect(() => {
    if (updateUnseenNotificationsStatus === "success") {
      dispatch(requestFetchNotifications({ start: null }));
      dispatch(resetUpdateUnseenNotifications());
    }
  }, [updateUnseenNotificationsStatus]);

  useEffect(() => {
    if (fetchNotificationsListStatus) {
      dispatch(resetFetchNotifications());
    }
  }, [fetchNotificationsListStatus]);

  useEffect(() => {
    if (fetchNotificationsListError) {
      dispatch(resetFetchNotifications());
    }
  }, [fetchNotificationsListError]);

  return (
    <>
      {isMobile ? (
        <>
          <section className="dashboard-upper-navigation-section mobile">
            <div className="inner-dashboard-upper-navigation-container">
              <Row className="dashboard-upper-navigation-row mobile">
                <Col className="logo-col text-left my-auto">
                  <img
                    alt="Leadfind logo"
                    className="mobile-logo"
                    src={logoDark}
                  />
                </Col>
                <Col className="company-select-col text-left my-auto">
                  <CompaniesDropdown
                    mobileCompaniesMenuOpen={mobileCompaniesMenuOpen}
                    setMobileCompaniesMenuOpen={setMobileCompaniesMenuOpen}
                    mobileMainMenuOpen={mobileMainMenuOpen}
                    setMobileMainMenuOpen={setMobileMainMenuOpen}
                  />
                </Col>
                <Col className="menu-col my-auto text-right">
                  <MobileMenu
                    mobileCompaniesMenuOpen={mobileCompaniesMenuOpen}
                    setMobileCompaniesMenuOpen={setMobileCompaniesMenuOpen}
                    mobileMainMenuOpen={mobileMainMenuOpen}
                    setMobileMainMenuOpen={setMobileMainMenuOpen}
                  />
                </Col>
              </Row>
            </div>
          </section>
          {isMobile && mobileMainMenuOpen ? (
            <section className="mobile-dropdown-menu">
              <div className="inner-mobile-dropdown-container">
                <Row className="upper-overview-row">
                  <Col className="thumbnail-col">
                    <img
                      alt={`${userInfo && userInfo.firstName} ${
                        userInfo && userInfo.lastName
                      }`}
                      className="user-thumbnail"
                      src={
                        userInfo && userInfo.thumbnail
                          ? userInfo.thumbnail
                          : accountThumbnail
                      }
                    />
                    <div
                      className="loader-container"
                      style={{
                        opacity:
                          authLoading ||
                          uploadLoading ||
                          thumbnailLoading ||
                          deleteLoading
                            ? "0.7"
                            : "0",
                      }}
                    >
                      <MoonLoader size={10} css={override} className="loader" />
                    </div>
                  </Col>
                  <Col className="details-col">
                    <span className="user-name">
                      {nameLoading && (
                        <i className="fas fa-circle-notch fa-spin"></i>
                      )}
                      {infoLoading && (
                        <i className="fas fa-circle-notch fa-spin"></i>
                      )}{" "}
                      {!nameLoading &&
                        !infoLoading &&
                        userInfo &&
                        userInfo.firstName}{" "}
                      {!nameLoading &&
                        !infoLoading &&
                        userInfo &&
                        userInfo.lastName}
                    </span>
                    <span className="companies-count">
                      {infoLoading && (
                        <i className="fas fa-circle-notch fa-spin"></i>
                      )}{" "}
                      {!infoLoading && userInfo
                        ? `Tilknyttet ${
                            userInfo.companies && userInfo.companies.length > 0
                              ? userInfo.companies.length
                              : "0"
                          } selskaper`
                        : ``}
                    </span>
                  </Col>
                  <Col className="edit-col text-right">
                    <button className="edit-profile-button">Min profil</button>
                  </Col>
                </Row>
                <hr />
                <div className="links-container">
                  <div onClick={() => navigatePage("overview")}>
                    <button
                      className={
                        activePage === "overview"
                          ? "menu-button w-100 d-block pt-2 pb-2 active"
                          : "menu-button w-100 d-block pt-2 pb-2"
                      }
                    >
                      <i className="fas fa-columns"></i> Oversikt{" "}
                      <i className="right-arrow fas fa-angle-right"></i>
                    </button>
                  </div>
                  <div
                    data-tip={`${
                      !activeLoading && company && !company.subscription
                        ? "Du har ikke tilgang til denne siden."
                        : ""
                    }`}
                    onClick={
                      company && company.subscription
                        ? () => navigatePage("lists")
                        : null
                    }
                  >
                    <button className={renderMenuDisplay("lists")}>
                      <i className="fas fa-stream"></i> Lister{" "}
                      <i className="right-arrow fas fa-angle-right"></i>
                    </button>
                  </div>
                  <div
                    data-tip={`${
                      !activeLoading && company && !company.subscription
                        ? "Du har ikke tilgang til denne siden."
                        : ""
                    }`}
                    onClick={
                      company && company.subscription
                        ? () => navigatePage("clients")
                        : null
                    }
                  >
                    <button className={renderMenuDisplay("clients")}>
                      <i className="fas fa-users"></i> Kunder{" "}
                      <i className="right-arrow fas fa-angle-right"></i>
                    </button>
                  </div>
                  <div
                    data-tip={`${
                      !activeLoading && company && !company.subscription
                        ? "Du har ikke tilgang til denne siden."
                        : ""
                    }`}
                    onClick={
                      company && company.subscription
                        ? () => navigatePage("pipeline")
                        : null
                    }
                  >
                    <button className={renderMenuDisplay("pipeline")}>
                      <i className="fas fa-filter"></i> Pipeline{" "}
                      <span className="badge">Beta</span>{" "}
                      <i className="right-arrow fas fa-angle-right"></i>
                    </button>
                  </div>
                  <div
                    data-tip={`${
                      !activeLoading && company && !company.subscription
                        ? "Du har ikke tilgang til denne siden."
                        : ""
                    }`}
                    onClick={
                      company && company.subscription
                        ? () => navigatePage("calendar")
                        : null
                    }
                  >
                    <button className={renderMenuDisplay("calendar")}>
                      <i className="far fa-calendar"></i> Kalender{" "}
                      <i className="right-arrow fas fa-angle-right"></i>
                    </button>
                  </div>
                  <div
                    data-tip={`${
                      !activeLoading && company && !company.subscription
                        ? "Du har ikke tilgang til denne siden."
                        : ""
                    }`}
                    onClick={
                      company && company.subscription
                        ? () => navigatePage("library")
                        : null
                    }
                  >
                    <button className={renderMenuDisplay("library")}>
                      <i className="far fa-folder-open"></i> Bibliotek{" "}
                      <i className="right-arrow fas fa-angle-right"></i>
                    </button>
                  </div>
                  {!activeLoading && company && company.admin && (
                    <div onClick={() => navigatePage("company")}>
                      <button
                        className={
                          activePage === "company"
                            ? "menu-button w-100 d-block pt-2 pb-2 active"
                            : "menu-button w-100 d-block pt-2 pb-2"
                        }
                      >
                        <i className="far fa-building"></i> Mitt Foretak{" "}
                        <i className="right-arrow fas fa-angle-right"></i>
                      </button>
                    </div>
                  )}
                  <hr />
                  <div
                    data-tip={`${
                      !activeLoading && company && !company.subscription
                        ? "Du har ikke tilgang til denne siden."
                        : ""
                    }`}
                    onClick={() => performSignout()}
                  >
                    <button className={renderMenuDisplay("library")}>
                      <i class="far fa-user"></i> Logg ut{" "}
                      <i className="right-arrow fas fa-angle-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </section>
          ) : null}
        </>
      ) : (
        <section className="dashboard-upper-navigation-section desktop text-right">
          <div className="inner-dashboard-upper-navigation-container">
            <Row className="dashboard-upper-navigation-row desktop">
              <Col className="company-select-col text-left my-auto">
                <CompaniesDropdown />
                {!infoLoading ? <NewSpaceButton /> : null}
                <InformationMessage />
              </Col>
              <Col className="user-dropdown-col my-auto text-right">
                <DropdownMenu
                  content="notifications"
                  type="notifications"
                  disabled={infoLoading ? true : false}
                  options={notifications}
                  toggle={renderNotificationsToggle()}
                  actions={[clickAcceptRequest, clickRejectRequest]}
                  open={notificationsDropdownOpen}
                  setOpen={setNotificationsDropdownOpen}
                  title="Varslinger"
                />
                <DropdownMenu
                  content="profile"
                  type="profile"
                  disabled={infoLoading ? true : false}
                  options={renderUserMenuOptions()}
                  data={{ userDetails: !infoLoading && renderUserDetails() }}
                  toggle={renderProfileToggle()}
                  open={profileDropdownOpen}
                  setOpen={setProfileDropdownOpen}
                  title="Kontoinnstillinger"
                />
              </Col>
            </Row>
          </div>
        </section>
      )}
      {modal.newSpaceModal ? <DashboardNewSpaceModal /> : null}
      {modal.resubscribeModal ? <DashboardResubcribeModal /> : null}
    </>
  );
};

export default DashboardUpperNavigation;
